import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-close-button',
    templateUrl: './close-button.component.html',
    styleUrls: ['./close-button.component.scss'],
    standalone: true,
    imports: [IconButtonComponent]
})
export class CloseButtonComponent {
    /* eslint-disable */
    @Input() color: string = 'var(--ion-color-dark)';
    @Input() buttonSize: number | undefined = undefined;
    @Input() iconSize: number = 24;
    @Input() backgroundColor: string = '';

    @Output() onClick = new EventEmitter();

    onCloseClick() {
        this.onClick.emit();
    }
}
